define('v3/Pages/AbilityGraph/Components/Filter/Filter.Component',[
	'knockout',
	'text!v3/Pages/AbilityGraph/Components/Filter/Filter.Component.html'
], function (ko, template) {
	function filter (params) {
		var self = this;
		self.options = ko.isObservable(params.options) ? ko.observableArray(params.options()) : ko.observableArray(params.options);
		self.caption = ko.observable(params.caption);
		self.optionsText = ko.observable(params.optionsText);
		self.optionsValue = ko.observable(params.optionsValue);

		self.selectedValue = params.selectedValue;

		return self;
	}

	filter.prototype.dispose = function () {
		this.selectedValue.dispose();
	};

	return { viewModel: filter, template: template };
});
